import { accommodationTypeZodObject } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-type";
import { resourceTypeZodEnum } from "@@/shared/acquire/resources/resource-type";
import { resourceShortNameZodString } from "@@/shared/acquire/resources/resource.short-name";
import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { reservationCheckInStatusValueZodEnum } from "@@/shared/statuses/reservation-check-ins/reservation-check-in-status";
import { z } from "zod";
import { resourceIdZodSchema } from "../../acquire/resources/resource-id";
import { iconNameZodString } from "../../icon-name";
import { requiredTranslatableZodSchema } from "../../translations/translation";

const checkInStatusZodObject = z.union([
    // Case when checkInEnabled is false
    z.object({
        enabled: z.literal(false),
        value: z.literal("NONE"),
        timestamp: z.literal(null),
    }),
    // Case when checkInEnabled is true
    z.object({
        enabled: z.literal(true),
        value: reservationCheckInStatusValueZodEnum,
        timestamp: isoAndUnixZodSchema,
    }),
]);

const _agendaResourceDataZodObject = z.object({
    resourceId: resourceIdZodSchema,
    resourceType: resourceTypeZodEnum,
    title: requiredTranslatableZodSchema,
    iconName: iconNameZodString,
    shortName: resourceShortNameZodString,
    checkInStatus: checkInStatusZodObject,
    // optional if correct type:
    accommodationType: accommodationTypeZodObject.optional(),
});
type AgendaResourceData = z.infer<typeof _agendaResourceDataZodObject> & {
    parentResources: AgendaResourceData[];
};
const agendaResourceDataZodObject: z.ZodType<AgendaResourceData> =
    _agendaResourceDataZodObject.extend({
        parentResources: z.lazy(() => z.array(agendaResourceDataZodObject)),
    });

export { agendaResourceDataZodObject };
export type { AgendaResourceData };
